/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MoneyTypeCoinsIcon16Light } from './MoneyTypeCoinsIcon16Light';
import { MoneyTypeCoinsIcon16Regular } from './MoneyTypeCoinsIcon16Regular';
import { MoneyTypeCoinsIcon16Solid } from './MoneyTypeCoinsIcon16Solid';
import { MoneyTypeCoinsIcon20Light } from './MoneyTypeCoinsIcon20Light';
import { MoneyTypeCoinsIcon20Regular } from './MoneyTypeCoinsIcon20Regular';
import { MoneyTypeCoinsIcon20Solid } from './MoneyTypeCoinsIcon20Solid';
import { MoneyTypeCoinsIcon24Regular } from './MoneyTypeCoinsIcon24Regular';
import { MoneyTypeCoinsIcon24Solid } from './MoneyTypeCoinsIcon24Solid';
import { MoneyTypeCoinsIcon32Regular } from './MoneyTypeCoinsIcon32Regular';
import { MoneyTypeCoinsIcon64Regular } from './MoneyTypeCoinsIcon64Regular';
var sizes = {
    16: {
        light: MoneyTypeCoinsIcon16Light,
        regular: MoneyTypeCoinsIcon16Regular,
        solid: MoneyTypeCoinsIcon16Solid,
    },
    20: {
        light: MoneyTypeCoinsIcon20Light,
        regular: MoneyTypeCoinsIcon20Regular,
        solid: MoneyTypeCoinsIcon20Solid,
    },
    24: {
        regular: MoneyTypeCoinsIcon24Regular,
        solid: MoneyTypeCoinsIcon24Solid,
    },
    32: {
        regular: MoneyTypeCoinsIcon32Regular,
    },
    64: {
        regular: MoneyTypeCoinsIcon64Regular,
    },
};
export var MoneyTypeCoinsIcon = forwardRef('MoneyTypeCoinsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
